import { navigateTo } from '../shared-constants/appEnums'
import { sharedPathes } from '../shared-routing/pathe'

export const navigateToHome = () => {
  const homeData = {
    location: navigateTo.HOME,
  }
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify(homeData))
  } else {
    window.parent.location.href = `${import.meta.env.VITE_MAIN_WEB_URL ||  "" }${sharedPathes.HOME}`

  }
}
